"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGradeColor = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const GradeColorKey_1 = __importDefault(require("./GradeColorKey"));
const getGradeColor = (color) => {
    switch (color) {
        case GradeColorKey_1.default.GREEN:
            return lib_palette_1.default.Greeny;
        case GradeColorKey_1.default.ORANGE:
            return lib_palette_1.default.OJ;
        case GradeColorKey_1.default.RED:
            return lib_palette_1.default.CoralRed;
        case GradeColorKey_1.default.PURPLE:
            return lib_palette_1.default.LibertyPurple;
        case GradeColorKey_1.default.BLUE:
            return lib_palette_1.default.GoodOldBlue;
        case GradeColorKey_1.default.BLACK:
        default:
            return lib_palette_1.default.Liquorice;
    }
};
exports.getGradeColor = getGradeColor;
exports.default = exports.getGradeColor;
